var a = /\w*$/;
function e(t) {
  var n = new t.constructor(t.source, a.exec(t));
  return n.lastIndex = t.lastIndex, n;
}
export {
  e as default
};
